import * as unidiff from "unidiff";
import { createUnchangedUnifiedDiff } from "./createUnchangedUnifiedDiff";

/**
 * Creates a unified diff between two text strings.
 *
 * This function uses the unidiff library to generate a unified diff format
 * compatible with react-diff-view.
 *
 * @param originalText - The original text content
 * @param updatedText - The updated text content
 * @param originalFileName - Name for the original file in diff headers (defaults to "original")
 * @param updatedFileName - Name for the updated file in diff headers (defaults to "updated")
 * @returns A unified diff string ready for use with react-diff-view
 */
export function createUnifiedDiff(originalText: string, updatedText: string, originalFileName: string = "original", updatedFileName: string = "updated"): string {
    let diff = unidiff.diffAsText(originalText, updatedText, {
        aname: originalFileName,
        bname: updatedFileName,
    });

    if (!diff) {
        // No diff found, creating unchanged diff
        diff = createUnchangedUnifiedDiff(originalText);
    }

    return diff;
}
